import { cloneElement, createElement, isValidElement, PureComponent, ReactElement } from 'react';

interface TabItemProps {
    label?: string | any;
    children: ReactElement;
}

export class TabItem extends PureComponent<TabItemProps> {
    render() {
        const { children, ...rest } = this.props;
        return <div>{isValidElement(children) ? cloneElement(children, rest) : createElement(children as any, rest)}</div>;
    }
}
